import { Button } from '@/components/ui';
import { cn } from '@/lib';
import { ArrowRightIcon } from 'lucide-react';
import React from 'react';

interface PriceCardProps {
  price: string;
  hover?: boolean;
}

export default function PriceCard(event: PriceCardProps): React.ReactNode {
  const isFreeEvent = event.price === '';

  return (
    <section className='from-gray-60 flex w-full items-center justify-between px-4 pb-4'>
      {isFreeEvent ? (
        <p className='text-sm font-bold uppercase'>Free</p>
      ) : (
        <p className='text-lg font-bold text-zinc-600 uppercase'>
          {event.price}
        </p>
      )}
      {/* <Button className={cn('rounded-full',{
        'bg-primary text-white': event.hover,
        'bg-primary': !event.hover,
      })}>
        <p className='text-xs font-semibold tracking-wide '>Book Now</p>
        <ArrowRightIcon strokeWidth={2.6} className='size-4' />
      </Button> */}
    </section>
  );
}
